import React, { useState } from "react";
import Table from "../../components/table";
import { TailSpin } from "react-loader-spinner";

const LogsTable = ({ data }: any) => {
  const columns = [
    // { header: "", accessor: "profilePhoto" },
    { header: "Timestamp", accessor: "created_at" },
    { header: "User", accessor: "performedBy" },
    { header: "Action", accessor: "action" },
    { header: "Entity", accessor: "logs_entity" },
    { header: "Description", accessor: "note" },
  ];

  return (
    <div className='rounded-md py-3 px-3 bg-white border border-[#fff] mt-10 w-[95%] pt-5 '>
      <div className='flex justify-between'>
        <p className='text-[18px] font-semibold'>All Accounts</p>
      </div>

      <Table
        columns={columns}
        data={data}
        selectedUserId={null}
        onUserClick={() => {}}
        sn={false}
        type='logs'
      />
    </div>
  );
};

export default LogsTable;
